import React, { Component } from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Api from "../../../../Services/Api";
import { mapToObjectDDL } from "../../../common/mapper";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { fetchDataAsync } from "../../../../Services/Utils";

class StockOpnameHeader extends Component {
  typeOptions = [
    {
      label: "Unit",
      value: "UNIT",
    },
    {
      label: "Part",
      value: "PART",
    },
    {
      label: "KSU",
      value: "KSU",
    },
    {
      label: "Hadiah",
      value: "GIFT",
    },
    {
      label: "Barang Lain",
      value: "OTHER_ITEM",
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      dataLocation: [],
      dataCabang: [],
    };
  }

  componentDidMount() {
    this.fetchDataLocation();
    this.fetchDataCabang();
    if (this.props.activityType === ACTIVITY_TYPE.CREATE) {
      this.props.setValue("kodeCabang", this.props.selectedCabang);
    }
  }

  fetchDataLocation = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")
        .getAllMasterLocationPagingByParam,
      menuName: "Stock Opname",
      setError: this.props.setError,
      args: {
        paramFilters: {
          kodeCabang: this.props.selectedCabang?.value,
        },
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevState) => ({
        ...prevState,
        dataLocation: res.data.data,
      }));
    }
  };

  fetchDataCabang = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).findAllMasterCabang();
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataCabang: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  render() {
    const selectedType =
      this.typeOptions.find(
        (opt) => opt.value === this.props.controls.stockOpnameType?.value?.value
      ) ?? null;

    return (
      <div className="grid grid-3x grid-mobile-none gap-20px">
        <div id="grid-1">
          <SimpleInput
            id="input_text_no_stock_opname"
            name="noStockOpname"
            label="No Stock Opname"
            mandatory
            errorMessage={this.props.errors.noStockOpname}
            readOnly={true}
            value={this.props.controls.noStockOpname.value}
          />

          <SimpleInput
            id="input_text_tgl_stock_opname"
            name="stockOpnameDate"
            label="Tgl Stock Opname"
            mandatory
            errorMessage={this.props.errors.stockOpnameDate}
            readOnly={true}
            value={this.props.controls.stockOpnameDate.value}
          />

          <SimpleDDL
            id="input_text_tipe"
            name="stockOpnameType"
            label="Tipe"
            box="search"
            mandatory
            errorMessage={this.props.errors.stockOpnameType}
            readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
            isClearable={this.props.activityType === ACTIVITY_TYPE.CREATE}
            options={this.typeOptions}
            value={selectedType}
            onChange={(value, { name }) => {
              this.props.setValue(name, value || {});
              this.props.resetTable();
            }}
          />
        </div>
        <div id="grid-2" />
        <div id="grid-3">
          <SimpleInput
            id="input_text_cabang"
            name="kodeCabang"
            label="Cabang"
            mandatory
            errorMessage={this.props.errors.kodeCabang}
            readOnly={true}
            value={this.props.selectedCabang?.label}
          />

          <SimpleDDL
            id="input_text_lokasi"
            name="kodeLocation"
            label="Lokasi"
            box="search"
            mandatory
            errorMessage={this.props.errors.kodeLocation}
            readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
            options={this.state.dataLocation.map((item) =>
              mapToObjectDDL(item.nameLocation, item.kodeLocation)
            )}
            value={this.props.controls.kodeLocation.value}
            onChange={(value, { name }) => {
              this.props.setValue(name, value)
              this.props.resetTable();
            }}
          />
        </div>
      </div>
    );
  }
}

export default StockOpnameHeader;
